import { message } from "antd";
import { handleLogoutFunc } from "src/utils";
import { token } from "src/static/const";
import axios from "axios";

export let host = "https://survey.hemis.uz/";

export let headers = {
  "X-Requested-With": "XMLHttpRequest",
  "Content-Type": "application/json; charset=utf-8",
  Authorization: token ? `Bearer ${token}` : "",
};

export let headersMultipart = {
  "X-Requested-With": "XMLHttpRequest",
  "Content-Type": "multipart/form-data",
  Authorization: token ? `Bearer ${token}` : "",
};

export let axiosInstance = axios.create({
  baseURL: `${host}api`,
  headers,
  timeout: 100000,
});

export let axiosInstanceOpen = axios.create({
  baseURL: `${host}api`,
  timeout: 100000,
});

export let axiosInstanceMultipart = axios.create({
  baseURL: `${host}api`,
  headers: headersMultipart,
  timeout: 100000,
});

axiosInstance.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error.response) {
      let obj = error.response.data;
      let { status } = error.response;
      if (status === 403 || status === 401) {
        handleLogoutFunc();
      } else if (status === 404) {
        message.error(
          "Ma'lumotlar topilmadi, iltimos qayta tekshirib ko'ring",
          5
        );
      } else if (status === 500) {
        message.error(
          "Server bilan bog'liq xatolik yuz berdi. Bu haqda ma'sul xodimlarga habar bering",
          5
        );
      } else {
        if (obj?.message) {
          message.error(obj.message, 10);
        } else if (obj.length > 0) {
          obj.forEach((item: any) => {
            message.error(item);
          });
        } else {
          for (let key in obj) {
            obj[key].forEach((item: any) => {
              message.error(item);
            });
          }
        }
      }
    }
    throw error;
  }
);
